import React, {useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import {fireScreenView, SCREEN_NAMES} from '../../util/Analytics';
import {theme} from '../../Theme';
import PrimaryButton from '../StyledComponents/PrimaryButton';
import StandardDialog from '../StyledComponents/StandardDialog';

const ListNumber = (props: $TSFixMe) => {
  return (
    <div
      style={{
        backgroundColor: props.color,
        width: 40,
        maxWidth: 25,
        height: 25,
        lineHeight: '25px',
        borderRadius: '50%',
        textAlign: 'center',
        fontFamily: 'AeonikProReqular',
        fontSize: 22,
        marginRight: 12,
      }}>
      {props.number}
    </div>
  );
};

export default function NonLoggedInUserDialog(props: $TSFixMe) {
  useEffect(() => {
    if (props.open) {
      fireScreenView(SCREEN_NAMES.NOT_LOGGED_IN_USER_DIALOG);
    }
  }, [props.open]);

  const history = useHistory();

  const redirect = `${window.location.pathname}${window.location.search}`;
  const encodedURI = encodeURIComponent(redirect);

  const benefitStyles = {display: 'flex', flexDirection: 'row', marginTop: 12};

  return (
    <StandardDialog
      open={props.open ? props.open : false}
      onClose={props.handleClose}
      primaryAction={
        <PrimaryButton
          onClick={() => {
            props.handleClose();
            history.push(`/login?redirect=${encodedURI}`);
          }}
          style={{marginBottom: 20}}>
          GET STARTED
        </PrimaryButton>
      }>
      <div>
        <DialogTitle>
          <Typography variant="h5" style={{fontSize: 24}}>
            CREATE AN ACCOUNT AND USE BIDMII FOR FREE
          </Typography>
        </DialogTitle>

        <DialogContent>
          {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ display: string; flexDirection: string; ma... Remove this comment to see the full error message */}
          <div style={benefitStyles}>
            <ListNumber number={1} color={theme.palette.purple.main} />
            <Typography variant="body2">
              {props.text
                ? props.text
                : 'Receive competing quotes from multiple contractors in your area'}
            </Typography>
          </div>
          {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ display: string; flexDirection: string; ma... Remove this comment to see the full error message */}
          <div style={benefitStyles}>
            <ListNumber number={2} color={theme.palette.blue.main} />
            <Typography variant="body2">
              {props.text
                ? props.text
                : 'All reviews are written by Bidmii users upon project completion'}
            </Typography>
          </div>
          {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ display: string; flexDirection: string; ma... Remove this comment to see the full error message */}
          <div style={benefitStyles}>
            <ListNumber number={3} color={theme.palette.green.main} />
            <Typography variant="body2">
              {props.text ? props.text : 'Your money is 100% protected'}
            </Typography>
          </div>
        </DialogContent>
      </div>
    </StandardDialog>
  );
}
